import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (consent) {
      try {
        const { expiry, value } = JSON.parse(consent);
        if (new Date().getTime() > expiry) {
          // Consent has expired, show banner again
          setIsVisible(true);
        }
      } catch (e) {
        // Invalid consent data, show banner
        setIsVisible(true);
      }
    } else {
      setIsVisible(true);
    }
  }, []);

  const saveConsent = (value: 'accepted' | 'customized') => {
    const oneYear = new Date().getTime() + (365 * 24 * 60 * 60 * 1000); // Current time + 1 year in milliseconds
    localStorage.setItem("cookie-consent", JSON.stringify({
      value,
      expiry: oneYear
    }));
    setIsVisible(false);
  };

  const handleAccept = () => {
    saveConsent('accepted');
  };

  const handleSettings = () => {
    saveConsent('customized');
    // TODO: Implement cookie settings modal in the future
    console.log("Open cookie settings");
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t shadow-lg p-4 z-50 animate-fadeIn">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm text-gray-600 flex-1">
          By clicking "Accept All", you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts.{" "}
          <button onClick={handleSettings} className="text-primary hover:underline">
            Privacy and Cookies Statement
          </button>
        </p>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={handleSettings}
          >
            Cookie Settings
          </Button>
          <Button
            size="sm"
            onClick={handleAccept}
            className="bg-primary hover:bg-primary/90"
          >
            Accept All
          </Button>
          <button
            onClick={() => setIsVisible(false)}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};